export const SET_ITEMS_WISHLIST = "WISHLIST/SET_ITEMS_WISHLIST"
export const SET_PAGINATION = "WISHLIST/SET_PAGINATION"
export const SET_COUNT_ITEMS_WISHLIST = "WISHLIST/SET_COUNT_ITEMS_WISHLIST"